import { safeDefine } from "../../registration/safe-define.js";
import { AirPlayButtonElement } from "../../ui/airplay-button/element.js";
//#region src/define/ui/airplay-button.ts
safeDefine(AirPlayButtonElement);
//#endregion
